'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _chord_lyrics_pair = require('./chord_lyrics_pair');

var _chord_lyrics_pair2 = _interopRequireDefault(_chord_lyrics_pair);

var _tag = require('./tag');

var _tag2 = _interopRequireDefault(_tag);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Represents a line in a chord sheet, consisting of items of type ChordLyricsPair or Tag
 */
var Line = function () {
  function Line() {
    _classCallCheck(this, Line);

    /**
     * The items ({@link ChordLyricsPair} or {@link Tag}) of which the line consists
     * @member
     * @type {Array.<(ChordLyricsPair|Tag)>}
     */
    this.items = [];

    /**
     * The line type, This is set by the ChordProParser when it read tags like {start_of_chorus} or {start_of_verse}
     * Values can be {@link VERSE}, {@link CHORUS} or {@link NONE}
     * @member
     * @type {string}
     */
    this.type = _constants.NONE;

    this.currentChordLyricsPair = null;
  }

  /**
   * Indicates whether the line contains any items
   * @returns {boolean}
   */


  _createClass(Line, [{
    key: 'isEmpty',
    value: function isEmpty() {
      return this.items.length === 0;
    }

    /**
     * Adds an item ({@link ChordLyricsPair} or {@link Tag}) to the line
     * @param {ChordLyricsPair|Tag} item The item to be added
     */

  }, {
    key: 'addItem',
    value: function addItem(item) {
      if (item instanceof _tag2.default) {
        this.addTag(item);
      } else if (item instanceof _chord_lyrics_pair2.default) {
        this.addChordLyricsPair(item);
      }
    }

    /**
     * Indicates whether the line contains items that are renderable
     * @returns {boolean}
     */

  }, {
    key: 'hasRenderableItems',
    value: function hasRenderableItems() {
      return this.items.some(function (item) {
        return item.isRenderable();
      });
    }

    /**
     * Returns a deep copy of the line and all of its items
     * @returns {Line}
     */

  }, {
    key: 'clone',
    value: function clone() {
      var clonedLine = new Line();
      clonedLine.items = this.items.map(function (item) {
        return item.clone();
      });
      clonedLine.type = this.type;
      return clonedLine;
    }

    /**
     * Indicates whether the line type is {@link VERSE}
     * @returns {boolean}
     */

  }, {
    key: 'isVerse',
    value: function isVerse() {
      return this.type === _constants.VERSE;
    }

    /**
     * Indicates whether the line type is {@link CHORUS}
     * @returns {boolean}
     */

  }, {
    key: 'isChorus',
    value: function isChorus() {
      return this.type === _constants.CHORUS;
    }

    /**
     * Indicates whether the line contains items that are renderable. Please use {@link hasRenderableItems}
     * @deprecated
     * @returns {boolean}
     */

  }, {
    key: 'hasContent',
    value: function hasContent() {
      return this.hasRenderableItems();
    }
  }, {
    key: 'addChordLyricsPair',
    value: function addChordLyricsPair(chords, lyrics) {
      if (chords instanceof _chord_lyrics_pair2.default) {
        this.currentChordLyricsPair = chords;
      } else {
        this.currentChordLyricsPair = new _chord_lyrics_pair2.default(chords, lyrics);
      }

      this.items.push(this.currentChordLyricsPair);
      return this.currentChordLyricsPair;
    }
  }, {
    key: 'ensureChordLyricsPair',
    value: function ensureChordLyricsPair() {
      if (!this.currentChordLyricsPair) {
        this.addChordLyricsPair();
      }
    }
  }, {
    key: 'chords',
    value: function chords(chr) {
      this.ensureChordLyricsPair();
      this.currentChordLyricsPair.chords += chr;
    }
  }, {
    key: 'lyrics',
    value: function lyrics(chr) {
      this.ensureChordLyricsPair();
      this.currentChordLyricsPair.lyrics += chr;
    }
  }, {
    key: 'addTag',
    value: function addTag(name, value) {
      var tag = name instanceof _tag2.default ? name : new _tag2.default(name, value);
      this.items.push(tag);
      return tag;
    }
  }]);

  return Line;
}();

exports.default = Line;


//////////////////
// WEBPACK FOOTER
// ./~/chordsheetjs/lib/chord_sheet/line.js
// module id = 72
// module chunks = 1